import { render, staticRenderFns } from "./NewsComponent.vue?vue&type=template&id=9957796e&scoped=true&"
import script from "./NewsComponent.vue?vue&type=script&lang=js&"
export * from "./NewsComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewsComponent.vue?vue&type=style&index=0&id=9957796e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9957796e",
  null
  
)

export default component.exports